import React from 'react';
import {Link} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
const {FiGlobe, FiInstagram, FiTwitter, FiFacebook} = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <div className="font-serif font-bold text-2xl tracking-wider mb-4">ANDREI CIOMÎRTAN</div>
            <p className="text-brand-accent font-medium text-sm mb-2 tracking-wide">
              Author · Blogger · Good Man in Relationship
            </p>
            <p className="text-slate-400 leading-relaxed max-w-sm text-sm">
              A book dedicated to helping people build deeper, more meaningful connections with the men in their lives.
            </p>
            <div className="flex gap-4 mt-6">
              <a href="https://ciomirtan.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-brand-accent transition-colors"><FiGlobe size={16} /></a>
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-brand-accent transition-colors"><FiInstagram size={16} /></a>
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-brand-accent transition-colors"><FiTwitter size={16} /></a>
              <a href="#" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-brand-accent transition-colors"><FiFacebook size={16} /></a>
            </div>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4 tracking-wide uppercase text-xs">Navigate</h4>
            <ul className="space-y-3">
              {[['Home', '/'], ['The Book', '/chapters'], ['About Author', '/about'], ['Reviews', '/reviews']].map(([label, path]) => (
                <li key={path}><Link to={path} className="text-slate-400 hover:text-brand-accent transition-colors text-sm">{label}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-white mb-4 tracking-wide uppercase text-xs">Buy the Book</h4>
            <ul className="space-y-3">
              {[
                ['Author Website', 'https://ciomirtan.com/book/how-to-love-a-good-man-the-8-essential-truths-of-the-male-heart/'],
                ['Kindle', 'https://www.amazon.com/dp/B0GTJRLQV9'],
                ['Paperback', 'https://www.amazon.com/dp/B0GTJHV5BB'],
                ['Hardcover', 'https://www.amazon.com/dp/B0GTLZFXQR'],
              ].map(([label, url]) => (
                <li key={url}><a href={url} target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-brand-accent transition-colors text-sm">{label}</a></li>
              ))}
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">&copy;{new Date().getFullYear()} Andrei Ciomîrtan. All rights reserved.</p>
          <p className="text-slate-600 text-xs">How to Love a Good Man — The 8 Essential Truths of the Male Heart</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;